import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {
    Button,
    Form, FormGroup, Label
} from 'reactstrap';
import { validateUserForm, createUser, updateUserData, deleteUserData } from './helper';
import UserCreatedData from './userCreated/index';

class CorrespondentUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allUsers: [],
            editUserFlag: true
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.userDetails !== prevProps.userDetails) {
            this.setState({
                allUsers: this.props.userDetails
            })
        }
    }
    saveUserDetails = (event) => {
        event.preventDefault();
        const validation = validateUserForm(this.props.userFormData.values, this.state.allUsers);
        if (validation.validationFlag) {
            const addUserData = createUser(this.state.allUsers, this.props.userFormData.values, this.props.correspondentId);
            this.setState({
                allUsers: addUserData,
                editUserFlag: false
            });
            this.props.userFormCallback(addUserData, validation)
            // this.props.reset();
            this.props.initialize({ firstName: '', lastName: '', email: '', contactNo: '' })
        } else {
            this.props.userFormCallback([], validation)
        }
    }
    resetUserDetails = (event) => {
        event.preventDefault();
        this.props.reset();
    }
    handleEditUserData = (userData) => {
        const userAllUpdatedData = updateUserData(userData, this.state.allUsers);
        this.setState({
            allusers: userAllUpdatedData
        })
        this.props.initialize(userData);
    }
    handleDeleteUser = (userData) => {
        const deletedData = deleteUserData(userData, this.state.allUsers);
        this.setState({
            allUsers: deletedData
        });
        this.props.deleteUserCallback(deletedData)
    }
    render() {
        return (
            <div>
                <UserCreatedData allUsers={this.state.allUsers} editUserFlag={this.state.editUserFlag} userCreatedDataCallback={this.handleEditUserData} deleteUserData={this.handleDeleteUser} />
                <Form>
                    <Field name="userName" value="" component="input" type="hidden" />
                    <FormGroup className="mb-4">
                        <Label for="firstName">First Name<span className="text-danger">*</span></Label>
                        <Field name="firstName" component="input" type="text" placeholder="Enter first name" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="lastName">Last Name<span className="text-danger">*</span></Label>
                        <Field name="lastName" component="input" type="text" placeholder="Enter last name" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="email">Email address<span className="text-danger">*</span></Label>
                        <Field name="email" component="input" type="text" placeholder="username@domain.com" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label for="contactNo">Contact<span className="text-danger">*</span></Label>
                        <Field name="contactNo" component="input" type="text" placeholder="9988775544" className='mb3 form-control' />
                    </FormGroup>
                    <FormGroup className="d-flex justify-content-end">
                        <Button type="submit" className="mr-3" color="primary" onClick={this.saveUserDetails}>Save</Button>
                        <Button type="submit" className="" color="primary" onClick={this.resetUserDetails}>Reset</Button>
                    </FormGroup>
                    <div className='error'>{this.state.errorMsg}</div>
                </Form>
            </div >
        )
    }
}

CorrespondentUserDetails = reduxForm({
    form: 'endUserDetailsForm',
    enableReinitialize: true
})(CorrespondentUserDetails)


const mapStateToProps = (state, ownProps) => ({
    userFormData: state.form.endUserDetailsForm
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default CorrespondentUserDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(CorrespondentUserDetails)